// Copyright 2021 The Simlin Authors. All rights reserved.
// Use of this source code is governed by the Apache License,
// Version 2.0, that can be found in the LICENSE file.

export const lineSpacing = 14;

export interface CommonLabelProps {
  uid: number;
  cx: number;
  cy: number;
  side: string;
  rw?: number;
  rh?: number;
}

export const LabelPadding = 4;
